import {NavLink} from 'react-router'
import cn from 'classnames'
import styles from './tab-bar.module.scss'

const ICONS = {
    dashboard: (
        <svg viewBox="0 0 24 24" className={styles.icon} aria-hidden="true">
            <path d="M3 12 12 4l9 8"/>
            <path d="M5 10v9h5v-6h4v6h5v-9"/>
        </svg>
    ),
    scenarios: (
        <svg viewBox="0 0 24 24" className={styles.icon} aria-hidden="true">
            <circle cx="6" cy="12" r="2.5"/>
            <circle cx="18" cy="6" r="2.5"/>
            <circle cx="18" cy="18" r="2.5"/>
            <path d="M8.5 12 15.5 6"/>
            <path d="M8.5 12 15.5 18"/>
        </svg>
    ),
    tasks: (
        <svg viewBox="0 0 24 24" className={styles.icon} aria-hidden="true">
            <rect x="4" y="5" width="16" height="14" rx="2"/>
            <path d="M8 10h8"/>
            <path d="M8 14h5"/>
        </svg>
    ),
    notifications: (
        <svg viewBox="0 0 24 24" className={styles.icon} aria-hidden="true">
            <path d="M6 16V11a6 6 0 0 1 12 0v5l1.5 2H4.5z"/>
            <path d="M10 20a2 2 0 0 0 4 0"/>
        </svg>
    ),
    me: (
        <svg viewBox="0 0 24 24" className={styles.icon} aria-hidden="true">
            <circle cx="12" cy="9" r="3.5"/>
            <path d="M5 20c1.2-3.4 4-5 7-5s5.8 1.6 7 5"/>
        </svg>
    )
}

const TABS = [
    {to: '/', label: 'Home', icon: 'dashboard', end: true},
    {to: '/scenarios', label: 'Scenarios', icon: 'scenarios'},
    {to: '/tasks', label: 'Tasks', icon: 'tasks'},
    {to: '/notifications', label: 'Alerts', icon: 'notifications'},
    {to: '/profile', label: 'Me', icon: 'me'}
]

/**
 * @param {{hideScenarios?: boolean}} props
 */
export function TabBar({hideScenarios = false}) {
    const tabs = hideScenarios
        ? TABS.filter(t => t.to !== '/scenarios')
        : TABS

    return (
        <nav className={styles.tabBar} role="tablist" aria-label="Primary">
            {tabs.map(tab => (
                <NavLink
                    key={tab.to}
                    to={tab.to}
                    end={tab.end}
                    className={({isActive}) => cn(styles.tab, {[styles.active]: isActive})}
                    role="tab"
                >
                    {ICONS[tab.icon]}
                    <span className={styles.label}>{tab.label}</span>
                </NavLink>
            ))}
        </nav>
    )
}
